import React from 'react';
import ImportDataWidget from 'app/shared/protocol/import-data-widget';

const InitialImportComponent = () => {
  return (
    <>
      <div className="p-md-3">
        <ImportDataWidget
          importLabel="Importovať produkty  (;)"
          importApi={`/api/products/import`}
          importFileName="produkty-protokoly.txt"
          acceptFormat=".csv"
          automaticallyDownloadProtocol={true}
        />
      </div>
      <div className="p-md-3">
        <ImportDataWidget
          importLabel="Importovať provízne schémy (;)"
          importApi={`/api/provision-schemes/import`}
          importFileName="provizne-schemy-protokoly.txt"
          acceptFormat=".csv"
          automaticallyDownloadProtocol={true}
        />
      </div>
      <div className="p-md-3">
        <ImportDataWidget
          importLabel="Importovať poradcov (;)"
          importApi={`/api/agents/import`}
          importFileName="poradcovia-protokoly.txt"
          acceptFormat=".csv"
          automaticallyDownloadProtocol={true}
        />
      </div>
      <div className="p-md-3">
        <ImportDataWidget
          importLabel="Importovať netto provízie poradcov (;)"
          importApi={`/api/agent-payed-netto-provision/import`}
          importFileName="poradca-netto-provizie-protokoly.txt"
          acceptFormat=".csv"
          automaticallyDownloadProtocol={true}
        />
      </div>
      <div className="p-md-3">
        <ImportDataWidget
          importLabel="Importovať klientov (|)"
          importApi={`/api/clients/import`}
          importFileName="klienti-protokoly.txt"
          acceptFormat=".csv"
          automaticallyDownloadProtocol={true}
        />
      </div>
      <div className="p-md-3">
        <ImportDataWidget
          importLabel="Importovať zmluvy (|)"
          importApi={`/api/contracts/import`}
          importFileName="zmluvy-protokoly.txt"
          acceptFormat=".csv"
          automaticallyDownloadProtocol={true}
        />
      </div>
      <div className="p-md-3">
        <ImportDataWidget
          importLabel="Prepojit zmluvy s dokumentami"
          importApi={`/api/contract-documents/import`}
          importFileName="dokumenty-protokoly.txt"
          acceptFormat=".csv"
          automaticallyDownloadProtocol={true}
        />
      </div>
      <div className="p-md-3">
        <ImportDataWidget
          importLabel="Aktualizovať stav a ročnú platbu zmluv (;)"
          importApi={`/api/contracts/import-update`}
          importFileName="aktualizacia-zmluv-protokoly.txt"
          acceptFormat=".csv"
          automaticallyDownloadProtocol={true}
        />
      </div>
      <div className="p-md-3">
        <ImportDataWidget
          importLabel="Importovať zaplatenosť zmluv pre Legal Counseling (excel)"
          importApi={`/api/contracts/import-zaplatenost-counseling`}
          importFileName="zaplatenost-counseling.txt"
          acceptFormat=".xlsx"
          automaticallyDownloadProtocol={true}
        />
      </div>
      <div className="p-md-3">
        <ImportDataWidget
          importLabel="Importovať zaplatenosť zmluv pre Accounting Services (excel)"
          importApi={`/api/contracts/import-zaplatenost-accounting`}
          importFileName="zaplatenost-accounting.txt"
          acceptFormat=".xlsx"
          automaticallyDownloadProtocol={true}
        />
      </div>
      <div className="p-md-3">
        <ImportDataWidget
          importLabel="Importovať platby NFA Invest (evidencia platieb, excel)"
          importApi={`/api/contracts/import-nfa-invest-payments`}
          importFileName="nfa-invest-platby-protokol.txt"
          acceptFormat=".xlsx"
          automaticallyDownloadProtocol={true}
        />
      </div>
    </>
  );
};

export default InitialImportComponent;
